"use client"

import { Image } from "@/elements"

import React, { FC } from "react"
import { FragmentType, graphql, useFragment } from "@/gql"
import { PencilLine } from "@/icons/outline/PencilLine"
import { ImageAddIcon } from "@/icons/outline/ImageAddIcon"
import { AddCoverImageModal } from "./AddCoverImageModal"
import clsx from "clsx"

const CoverImageWithEditFragment = graphql(`
  fragment CoverImageWithEdit on JobPosting {
    __typename
    id
    coverImage {
      id
      thumbnailUrl645: thumbnailUrl(width: 645)
    }
  }
`)

interface Props {
  jobPosting: FragmentType<typeof CoverImageWithEditFragment> | undefined | null
  className?: string
  size?: "sm" | "lg"
}

export const CoverImageWithEdit: FC<Props> = ({ className, size = "lg", ...props }) => {
  const [showModal, setShowModal] = React.useState(false)
  const jobPosting = useFragment(CoverImageWithEditFragment, props.jobPosting)
  const image = jobPosting?.coverImage?.thumbnailUrl645

  return (
    <div>
      <AddCoverImageModal
        open={showModal}
        onOpenChange={setShowModal}
        jobPostId={jobPosting?.id || ""}
        jobPostTypename={jobPosting?.__typename as "ClientJobPosting" | "CreativeJobPosting"}
      />
      <div
        data-prevent-nprogress={true}
        className={clsx(
          size === "lg" ? "size-[72px] lg:size-[120px]" : "size-[36px]",
          "group relative flex shrink-0 cursor-pointer overflow-hidden rounded-md bg-bg-3",
          className
        )}
        onClick={e => {
          e.stopPropagation()
          e.preventDefault()

          setShowModal(true)
        }}>
        {image ? (
          <Image
            srcSetUrls={{
              sm: image,
            }}
            alt="Cover image"
            className="h-full w-full object-cover"
            loading="eager"
          />
        ) : (
          <div className="flex h-full w-full items-center justify-center">
            <ImageAddIcon className="stroke-fg-2" />
          </div>
        )}
        {!!image && (
          <div className="absolute left-1/2 top-1/2 z-10 flex size-9 -translate-x-1/2 -translate-y-1/2 transform cursor-pointer items-center justify-center rounded-full bg-fg-1 bg-opacity-35 opacity-0 backdrop-blur-md transition-opacity group-hover:opacity-100">
            <PencilLine height={20} width={20} className="text-bg-1" />
          </div>
        )}
      </div>
    </div>
  )
}
